module.exports = __webpack_public_path__ + "static/img/bystage_07.b4c987ee.svg";